import {COOKIE_JWT} from '@helper/constant';
import {getCookieFromBrowser} from '@helper/cookie';
import AccountService from '@services/account.service';
import ConfigService from '@services/config.service';
import {useRouter} from 'next/router';
import {createContext, useContext, useEffect, useState} from 'react';

const redirectKey = 'login_vmf';

const AuthContext = createContext({
    initializing: false,
    user: null,
    error: null,
    setRedirect: redirect => {},
    getRedirect: () => {},
    clearRedirect: () => {},
    config: {},
    policyServiceConfig: {},
    contactConfig: {},
    lang: 'vn',
    setLang: () => {},
    setUser: () => {},
});
AuthContext.displayName = 'AuthContext';

function setRedirect(redirect) {
    window.sessionStorage.setItem(redirectKey, redirect);
}

function getRedirect() {
    return window.sessionStorage.getItem(redirectKey);
}

function clearRedirect() {
    return window.sessionStorage.removeItem(redirectKey);
}

const _configService = new ConfigService();
const _accountService = new AccountService();

export function AuthProvider({children}) {
    const route = useRouter();
    const {locale} = route;
    const [error, setError] = useState(null);
    const [initializing, setInitializing] = useState(true);
    const [lang, setLang] = useState(locale);
    const [config, setConfig] = useState({});
    const [policyServiceConfig, setPolicyServiceConfig] = useState(null);
    const [contactConfig, setContact] = useState(null);

    useEffect(() => {
        initData();
        setLang(locale);
    }, [locale]);

    const initData = async () => {
        setInitializing(true);
        try {
            if (getCookieFromBrowser(COOKIE_JWT)) {
                let user = await _accountService.getUser();
                setUser(user);
                initCart();
            }
            let config = await _configService.getConfigWeb({locale});
            setConfig(config);
            let configPolicyService = await _configService.getPolicyServiceConfig();
            setPolicyServiceConfig(configPolicyService.POLICY_AND_SERVICE.value);
            let dataContact = await _configService.getContact();
            setContact(dataContact.config);
        } catch (error) {
            setError(error);
            setUser(null);
            setInitializing(false);
            setOrder({
                products: [],
                sub_total: 0,
                total: 0,
                coupon: null,
                promotions: [],
                discount_promotion: 0,
                total_discount: 0,
                discount_products: 0,
                discount_coupon: 0,
                discount_promotion_view: 0,
            });
        } finally {
            setInitializing(false);
        }
    };

    const value = {
        user,
        error,
        initializing,
        setRedirect,
        getRedirect,
        clearRedirect,
        logout,
        setUser,
        setInitializing,
        lang,
        setLang,
        config,
        policyServiceConfig,
        contactConfig,
    };
    return (
        <AuthContext.Provider value={value}>
            {children}
            {isSignInModal ? (
                <SignInModal
                    setIsSignInModal={setIsSignInModal}
                    setIsSignUpModal={setIsSignUpModal}
                    setIsForgetPassword={setIsForgetPassword}
                    // setUser={setUser}
                />
            ) : null}
            {isSignUpModal ? (
                <SignUpModal setIsSignUpModal={setIsSignUpModal} setIsSignInModal={setIsSignInModal} />
            ) : null}
            {isForgetPassword ? (
                <ForgetPasswordModal setIsSignInModal={setIsSignInModal} setIsForgetPassword={setIsForgetPassword} />
            ) : null}
        </AuthContext.Provider>
    );
}
export const useAuth = () => useContext(AuthContext);
